export const addIdentity = (user) => ({
  type: "mixpanel/ADD_IDENTITY",
  payload: user,
});

export const clearMixpanelAll = () => ({
  type: "mixpanel/CLEAR_ALL",
});
